"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _goToPage = require("./goToPage");
Object.keys(_goToPage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _goToPage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _goToPage[key];
    }
  });
});
